import styles from './LeftNav.module.scss';
import {Logo, NavMenu} from '../../components';
import { IMAGE_ALT, THEME } from '../../constants';
import SocialIcons from '../../components/socialIcons/SocialIcons';
import siriusLightMode from '../../assets/images/siriusLightMode.png';
import siriusDarkMode from '../../assets/images/siriusDarkMode.png';
import lightModeLogo from '../../assets/logos/lightModeLogo.png';
import darkModeLogo from '../../assets/logos/darkModeLogo.png';
import useViewport from '../../hooks/useViewport';
import PropTypes from 'prop-types';
import { VIEWPORT_BREAKPOINTS, URL_CONSTANTS, HOME_ROUTE } from '../../constants';
import { NavLink } from 'react-router-dom';
import openLink from '../../utils/openLink';

function LeftNav(props) {
  const { handleTheme, theme, setHamburgerOpen, isHamburgerOpen } = props;
  // To get viewport width
  const { viewportWidth } = useViewport();

  const leftNavComponent = (
    <div className={viewportWidth <= VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES ? `${styles.leftNavContainer} ${styles.overlayContainer}` : styles.leftNavContainer}>
      {viewportWidth > VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES ? (
        <NavLink to="/home" className={styles.logoContainer}>
          <Logo image={theme === THEME.LIGHT ? lightModeLogo : darkModeLogo}></Logo>
        </NavLink>
      ) : (
        isHamburgerOpen && (
          <NavLink to={HOME_ROUTE} className={styles.logoContainer}>
            <Logo
              image={theme === THEME.LIGHT  ? lightModeLogo : darkModeLogo}></Logo>
          </NavLink>
        )
      )}
      <div className={styles.menu}>
        <NavMenu
          setHamburgerOpen={setHamburgerOpen}
          isHamburgerOpen={isHamburgerOpen}
          handleTheme={handleTheme}
          theme={theme}></NavMenu>
      </div>
      <div className={styles.socialIcons}>
        <SocialIcons />
      </div>
      <div className={styles.siriusLogo} onClick={() => openLink(URL_CONSTANTS.sirius)}>
        {theme === THEME.LIGHT ? (
          <img src={siriusLightMode} alt={IMAGE_ALT.SIRIUS}></img>
        ) : (
          <img src={siriusDarkMode} alt={IMAGE_ALT.SIRIUS}></img>
        )}
      </div>
    </div>
  );

  return (
    <>
      {viewportWidth > VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES
        ? leftNavComponent
        : isHamburgerOpen && leftNavComponent}
    </>
  );
}

LeftNav.propTypes = {
  theme: PropTypes.string,
};
export default LeftNav;
